import React from 'react';


const tecno = [
    { T: 'Unity', L: 'https://unity.com/es' },
    { T: 'C#', L: 'https://docs.microsoft.com/en-us/dotnet/csharp/' },
];


class Runordie extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">









                    <div className="sectionProyect">


                        <div className="titleSectionProyect">
                            <h1>Run Or Die</h1>

                        </div>
                        <svg> <rect></rect> </svg>

                        <iframe  src="https://www.youtube.com/embed/F5tuGQg71uw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <div className="listT" >

                            {tecno.map(tec => (
                                <div key={tec}>
                                    <a href={tec.L} target="_blank" rel="noreferrer">

                                        <button className="animateButtonTech">  <p> <span>&#183;</span> {tec.T}</p></button>
                                    </a>
                                </div>

                            ))}
                        </div>

                        <p>This game was created with Unity and consists of escaping from the steamroller so as not to die, the terrain is procedural so in general it has no end! You accumulate points the further you advance in the game.</p>

                        <a href="https://github.com/BrandonGrimaldoM/RunOrDieGame" target="_blank" rel="noreferrer">
                            <button className="animateButtonGit"> <p>Repository </p> <div className="gitIcon"></div> </button>
                        </a>
                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default Runordie;